import { Component, OnInit } from '@angular/core';
import { ResearcherService, MessageQueService} from '../../services/index';
import PopupHelper from '../../models/popupHelper';
import { AlertResult } from '../../models/alertifyPromise';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tasklist-comments',
  templateUrl: 'researcherTaskComment.component.html',
  styleUrls: ['researcherTaskComment.component.scss'],
  providers: [ResearcherService,  MessageQueService]
})

export class ResearcherTaskCommentComponent implements OnInit {
  model: any = {};
  constructor(private router: Router,  private msgSvc: MessageQueService, private researcherService: ResearcherService) {

    this.model.status = JSON.parse(localStorage.getItem('status'));
    this.model.requestNbr = (localStorage.getItem('requests'));
    localStorage.removeItem('status');

    this.researcherService.getResearchTaskComment(this.model.requestNbr)
      .subscribe(
      (data) => {
        this.model.comment = data;
      });
  }
  ngOnInit() {
   this.msgSvc.setControlKey();
  }
  submit() {
    this.researcherService.saveResearcherTaskComments(this.model.requestNbr, this.model.comment)
      .subscribe(
      (data) => {
        if (data === 200) {
          window.close();
        } else if (data === 401) {
          window.close();
          this.router.navigate(['login']);
        }
      });
  }
  deleteComment() {
    if (this.model.comment != null) {
      this.researcherService.deleteResearcherTaskComments(this.model.requestNbr)
        .subscribe(
        (data) => {
          if (data === 200) {
            window.close();
          } else if (data === 401) {
            window.close();
          }
        });
    } else {
      window.close();
    }
  }
  doSubmit(type: string) {
    if (type === 'Save') {
      if (this.model.change === false) {
        type = 'Cancel';
        this.submit();
      } else {
        this.saveAlertBox();
      }
    } else if (type === 'Cancel') {
      window.close();
    } else if (type === 'Delete') {
      this.deleteComment();
    }
  }
  checkStatus() {
    if (this.model.status === 'W' || this.model.status === 'C' || this.model.status === 'U') {
      return false;
    } else {
      return true;
    }
  }
  isEnabled() {
    if (this.model.status === 'W' || this.model.status === 'C' || this.model.status === 'U') {
      return true;
    } else {
      return false;
    }
  }
  commentChanged() {
    this.model.change = true;
  }
  async saveAlertBox() {
    const message = `During times of heavy system activity, Task Comments may
    take up to 5-10 minutes to post. This is expected behavior.
    Thank you for your understanding`;
    const alertResult = await PopupHelper.saveComment(message);
    if (alertResult === AlertResult.Ok) {
      this.submit();
    }
  }
  about() {
    PopupHelper.systemVersion();
  }
  support() {
    PopupHelper.support();
  }
}



// WEBPACK FOOTER //
// ./src/app/researcherTaskComment/researcherTaskComment.component.ts